import { render, staticRenderFns } from "./Phrases.vue?vue&type=template&id=07c0e534&"
import script from "./Phrases.vue?vue&type=script&lang=js&"
export * from "./Phrases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Phrases.vue"
export default component.exports